import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import { getClientMessages, getModalMessages } from '../../../../constants/messages';
import ClientAccountsView from './View';

let clientMessages = getClientMessages(),
	modalMessages = getModalMessages();

const messages = {
	...clientMessages,
	...modalMessages,
};

class ClientAccountsModal extends React.Component {
	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	renderButtons = () => {
		const { props, getIntl } = this;
		const { handleCancel } = props;
		return [
			<Button key="close" onClick={handleCancel}>
				{getIntl('close')}
			</Button>,
		];
	};

	render() {
		const { props, getIntl, renderButtons } = this;
		const { clientId, showModal, handleCancel } = props;
		return (
			<Modal
				open={showModal}
				title={getIntl('clientAccounts')}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={renderButtons()}
			>
				<ClientAccountsView clientId={clientId} />
			</Modal>
		);
	}
}

ClientAccountsModal.propTypes = {
	intl: PropTypes.object.isRequired,
	showModal: PropTypes.bool.isRequired,
	clientId: PropTypes.number.isRequired,
	handleCancel: PropTypes.func.isRequired,
};

export default injectIntl(ClientAccountsModal);
